(() => {
	/**
	 * Pricing Card — "See full plan details" disclosure.
	 *
	 * The collapse itself is CSS: `data-details-open` on the card hides the panel,
	 * and `aria-expanded` on the button drives the label swap and the chevron
	 * flip. This only sets the two attributes, which means a card with JS
	 * unavailable renders with its details already open rather than behind a
	 * button that does nothing.
	 */
	document.querySelectorAll('.block-pricing-card').forEach((card) => {
		const toggle = card.querySelector('.block-pricing-card__details-toggle');
		if (!toggle) return;

		const setOpen = (open) => {
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			card.dataset.detailsOpen = open ? 'true' : 'false';
		};

		setOpen(false);

		toggle.addEventListener('click', () => {
			setOpen(toggle.getAttribute('aria-expanded') !== 'true');
		});
	});
})();
